import PropTypes from "prop-types";
import React, { Component } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import MDialog, { ACTION_APPLY, ACTION_CLOSE } from "components/Shared/MDialog.tsx";

class MDialogSelectList extends Component {
  constructor(props) {
    super(props);

    this.getActions = this.getActions.bind(this);
    this.rowClicked = this.rowClicked.bind(this);
    this.onApply = this.onApply.bind(this);

    let data = props.data.slice(0);

    if (props.showSelectAll) {
      data.unshift({
        checked: data.every((d) => d.checked),
        label: props.selectAllLabel || "Select All",
        isSelectAll: true,
      });
    }

    this.state = {
      data: data,
    };
  }

  onApply() {
    this.props.onApply(this.state.data.filter((d) => !d.isSelectAll));
  }

  getActions() {
    let actions = [];

    if (this.props.onApply) actions.push({ code: ACTION_APPLY, onClick: this.onApply });
    if (this.props.onClose) actions.push({ code: ACTION_CLOSE, onClick: this.props.onClose });
    if (this.props.onRefresh)
      actions.push({
        icon: "replay",
        helpText: this.props.refreshText || "Reset",
        onClick: this.props.onRefresh,
        order: 0,
      });

    return actions;
  }

  rowClicked(row) {
    let newData = this.state.data.map((d) => Object.assign({}, d));
    row = newData.find((d) => d.label === row.label);

    row.checked = !row.checked;

    if (row.isSelectAll) {
      newData.forEach((d) => (d.checked = row.checked));
    } else {
      if (this.props.showSelectAll) {
        newData.find((d) => d.isSelectAll).checked = newData.every((d) => d.checked || d.isSelectAll);
      }
    }

    this.setState({ data: newData });
  }

  render() {
    return (
      <MDialog
        id={this.props.id}
        title={this.props.title}
        actions={this.getActions()}
        focusOnMount={this.props.focusOnMount}
        dontSpecifyWidth
      >
        {(this.props.valueTitle || this.props.labelTitle) && (
          <Box sx={{ display: "flex", px: 2, py: 1, borderBottom: 1, borderColor: "divider" }}>
            <Typography variant="subtitle2" sx={{ width: 42, flexShrink: 0 }}>
              {this.props.valueTitle || ""}
            </Typography>
            <Typography variant="subtitle2" sx={{ flexGrow: 1 }}>
              {this.props.labelTitle || ""}
            </Typography>
          </Box>
        )}
        <List dense sx={{ overflow: "auto" }}>
          {this.state.data.map((row) => (
            <ListItem key={row.label} disablePadding>
              <ListItemButton
                onClick={(e) => {
                  e.preventDefault();
                  this.rowClicked(row);
                }}
                sx={{ "&:hover": { backgroundColor: "var(--hover-color)" } }}
              >
                <ListItemIcon sx={{ minWidth: 42 }}>
                  <Checkbox edge="start" checked={row.checked} tabIndex={-1} disableRipple onChange={() => {}} />
                </ListItemIcon>
                <ListItemText primary={row.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </MDialog>
    );
  }
}

MDialogSelectList.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  valueTitle: PropTypes.string,
  labelTitle: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object), //[{ checked, label }]
  showSelectAll: PropTypes.bool,
  selectAllLabel: PropTypes.string,
  onApply: PropTypes.func, //called with data as a parameter
  onClose: PropTypes.func,
  onRefresh: PropTypes.func,
  refreshText: PropTypes.func,
  focusOnMount: PropTypes.bool,
  width: PropTypes.number,
};

export default MDialogSelectList;
